import React from "react";
import { Password } from 'primereact/password';

const InputPassword = ({value, onChange, label,errorMessage, required}) => {
  return (
    <div style={{maxWidth:'100%'}}>
        <Password inputId="password"  invalid={errorMessage} value={value} onChange={onChange} feedback={false}
       toggleMask placeholder={label} required={required} id={label}/>
        {/* {errorMessage && 
            <small id="username-help">
              {errorMessage}
            </small>} */}
   
    </div>

  )
}

export default InputPassword
